
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/submissions",
      function () {
        return require("private-next-pages/submissions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/submissions"])
      });
    }
  